import { Activity, ArrowRight, Database, ShieldCheck } from 'lucide-react';
import { Link } from 'react-router-dom';
import { getSurfaceDashboardElement } from '#surface-entry';
import { useAuth } from '../AuthContext';
import { getDisplayName } from '../lib/auth';
import type { AdminSurfaceConfig } from '../surface';

interface DashboardPageProps {
  surfaceConfig: AdminSurfaceConfig;
}

export default function DashboardPage({ surfaceConfig }: DashboardPageProps) {
  const { user, profile } = useAuth();
  const displayName = getDisplayName(profile, user);
  const primaryItems = surfaceConfig.navItems.filter((item) => item.path !== '/').slice(0, 4);
  const surfaceDashboardElement = getSurfaceDashboardElement(surfaceConfig);

  return (
    <div className="page-stack">
      <section className="page-heading">
        <div>
          <p className="section-eyebrow">Dashboard</p>
          <h2>{displayName}님, 운영 콘솔에 연결되었습니다.</h2>
        </div>
        <span className="status-pill">Role: {profile?.role}</span>
      </section>

      {surfaceDashboardElement ? (
        surfaceDashboardElement
      ) : (
        <>
          <section className="stat-grid" aria-label="운영 상태">
            <div className="stat-card">
              <ShieldCheck size={22} />
              <span>권한 경계</span>
              <strong>{surfaceConfig.allowedRole}</strong>
            </div>
            <div className="stat-card">
              <Database size={22} />
              <span>Backend</span>
              <strong>Cloudflare Worker + D1</strong>
            </div>
            <div className="stat-card">
              <Activity size={22} />
              <span>Surface</span>
              <strong>{surfaceConfig.surface}</strong>
            </div>
          </section>

          <section className="action-grid" aria-label="주요 메뉴">
            {primaryItems.map((item) => {
              const Icon = item.icon;
              return (
                <Link key={item.path} className="action-tile" to={item.path}>
                  <Icon size={22} />
                  <span>
                    <strong>{item.label}</strong>
                    <small>{item.description}</small>
                  </span>
                  <ArrowRight size={18} />
                </Link>
              );
            })}
          </section>
        </>
      )}
    </div>
  );
}
